import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const PageHeading: React.FC = () => {
	return (
		<div className="text-typography-strong space-y-2 pt-6 md:pt-10">
			<Text size="large" className="text-typography-weak">
				<Translate value="corgi.location_page_sitemap.page_heading.subtitle" />
			</Text>

			<Text as="h1" variant="heading" size="x-large" className="text-typography-strong">
				<Translate value="corgi.location_page_sitemap.page_heading.title" />
			</Text>
		</div>
	);
};
